import type { TFunction } from 'i18next';

export const STAGE_I18N_SLUG: Record<string, string> = {
  'Value Proposition': 'valueProposition',
  Quotation: 'quotation',
  Demonstration: 'demonstration',
  Negociation: 'negociation',
  Closed: 'closed',
};

export function getStageLabel(stage: string, t: TFunction): string {
  const slug = STAGE_I18N_SLUG[stage];
  return slug ? t(`opportunity.stage.${slug}`) : stage;
}
